export default {"src":"/_next/static/media/apple.7ca77982.svg","height":44,"width":180,"blurWidth":0,"blurHeight":0};